import React, { memo, useCallback, useEffect, useMemo, useState } from "react";

import formatLastUpdate from "common/format-last-update";
import formatIndexNumber from "common/format-index-number";

import { enquiryStatusOptions } from "constants/enquiry-status-options";

import EnquiryTableProps from "dto/components/pages/enquiry/page-enquiry-table-dto";

import AppPagination from "components/app-pagination";
import AppSelectInput from "components/app-select-input";

const EnquiryTable: React.FC<EnquiryTableProps> = ({ enquiries, onUpdateStatus, onHandlePageChange, fetching, paginationTable }) => {
	const startIndex = paginationTable.currentPage * paginationTable.tableSize;
	const [status, setStatus] = useState<{ id: string; status: string } | null>(null);
	const isEmptyData = useMemo(() => enquiries.length === 0 && !fetching, [enquiries.length, fetching]);
	const [isReadyData, setIsReadyData] = useState<boolean>(fetching);

	//prettier-ignore
	const onHandleInputChange = useCallback((id: string, value: string) => {
		setStatus({id: id, status: value});
		setIsReadyData(false);

		onUpdateStatus({id: id, status: value});
	}, [onUpdateStatus]);

	useEffect(() => {
		if (!fetching) setIsReadyData(true);
	}, [fetching]);

	useEffect(() => {
		if (isReadyData) setStatus(null);
	}, [isReadyData]);

	return (
		<div className="app-enquiry-table">
			<div className="enquiry-table">
				<div className="enquiry-table__wrapper">
					<table className="enquiry-table__container">
						<thead className="enquiry-table__header">
							<tr>
								<th className="enquiry-table__th">No.</th>
								<th className="enquiry-table__th">Company Name</th>
								<th className="enquiry-table__th">Email</th>
								<th className="enquiry-table__th">Phone No.</th>
								<th className="enquiry-table__th">Channel</th>
								<th className="enquiry-table__th">Message</th>
								<th className="enquiry-table__th">Submission Date</th>
								<th className="enquiry-table__th">Status</th>
							</tr>
						</thead>

						<tbody className="enquiry-table__content">
							{enquiries.map((enquiry, index) => {
								return (
									<tr className="enquiry-table__tr" key={enquiry.id}>
										<td className="enquiry-table__td">{formatIndexNumber(index + 1 + startIndex)}</td>

										<td className="enquiry-table__td">{enquiry.companyName}</td>

										<td className="enquiry-table__td">{enquiry.email}</td>

										<td className="enquiry-table__td">{enquiry.phone}</td>

										<td className="enquiry-table__td">{enquiry.channel}</td>

										<td className="enquiry-table__td">{enquiry.message}</td>

										<td className="enquiry-table__td">{formatLastUpdate(enquiry.createdAt)}</td>

										<td className="enquiry-table__td">
											{/* prettier-ignore */}
											<AppSelectInput name="status" placeholder={enquiry.status} value={status && status.id === enquiry.id ? status?.status : enquiry.status} onChange={(e) => onHandleInputChange(enquiry.id, e.target.value)} options={enquiryStatusOptions} searchable={false} />
										</td>
									</tr>
								);
							})}

							{fetching && (
								<tr className="enquiry-table__tr">
									<td className="enquiry-table__message" colSpan={7}>
										Loading...
									</td>
								</tr>
							)}

							{isEmptyData && (
								<tr className="enquiry-table__tr">
									<td className="enquiry-table__message" colSpan={7}>
										No records found
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				{!isEmptyData && !fetching && (
					<AppPagination currentPage={paginationTable.currentPage} totalPages={paginationTable.totalPages} onPageChange={onHandlePageChange} numberOfElements={paginationTable.numberOfElements} />
				)}
			</div>
		</div>
	);
};

export default memo(EnquiryTable);
